import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWithPhotoTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const WithPhotoTagItem = (props: IWithPhotoTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      С фото
    </TagComponent>
  );
};
